import { queryOptions, useQuery } from '@tanstack/react-query'
import { api } from '@/api/client'
import type { MembershipsResponse } from '@/api/pending'
import { queryKeys } from '@/api/queryKeys'

/** Re-checked on focus so a capability change applies without a reload. */
export const membershipsQuery = queryOptions({
  queryKey: queryKeys.memberships,
  queryFn: ({ signal }) => api.get<MembershipsResponse>('/users/me/memberships', { signal }),
  staleTime: 60_000,
  refetchOnWindowFocus: true,
})

export function useMemberships() {
  return useQuery(membershipsQuery)
}
